import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  text: {
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontWeight: 600,
  },
}));

export default useStyles;
